"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createComposedLog;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createComposedLog() {
  var globalData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    _logs: [],
    _logCache: {},
    _pairsFound: {},

    /* key/value merge -> {key, value, count} */
    _requiredUnique: {
      timestamp: true,
      time: true,
      clientStartTime: true,
      duration: true,
      success: true
    },
    size: function size() {
      return this._logs.length;
    },
    add: function add(message, data) {
      var sortedKeys = Object.keys(data).sort();
      var sorted = {};
      var flatData = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = sortedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;
          var keyValuePrint = "".concat(key).concat(data[key]);
          var isUnique = this._requiredUnique[key] === true;
          flatData += keyValuePrint;

          if (!isUnique && this._pairsFound[keyValuePrint] !== undefined) {
            this._pairsFound[keyValuePrint].count += 1;
          } else if (!isUnique) {
            this._pairsFound[keyValuePrint] = {
              key: key,
              value: data[key],
              count: 1
            };
          }

          if (isUnique || this._pairsFound[keyValuePrint].count < 2) {
            sorted[key] = data[key];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var cacheKey = "".concat(message).concat(flatData); // check for duped log

      if (this._logCache[cacheKey] === true) return;
      this._logCache[cacheKey] = true;

      this._logs.push({
        message: message,
        data: sorted,
        sortedKeys: sortedKeys
      });
    },
    serialize: function serialize() {
      var deduped = this._dedupeCommonFields();

      var toSerialize = _objectSpread({}, deduped.common, globalData);

      toSerialize.logList = deduped.logs;
      return JSON.stringify(toSerialize);
    },
    _dedupeCommonFields: function _dedupeCommonFields() {
      var logs = [];
      var common = {}; // for each log, create a new version with deduped data fields, add to final logs, add duped to common

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this._logs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var log = _step2.value;
          var dedupedLog = {
            message: log.message,
            msg: log.message
          };
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = log.sortedKeys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var key = _step3.value;

              var pairRecord = this._pairsFound["".concat(key).concat(log.data[key])];

              if ((pairRecord === undefined || pairRecord.count < 2) && globalData[key] !== log.data[key]) {
                dedupedLog[key] = log.data[key];
              } else if (pairRecord && pairRecord.count > 1 && common[key] === undefined) {
                common[key] = pairRecord.value;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          logs.push(dedupedLog);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return {
        common: common,
        logs: logs
      };
    }
  };
}

;